module.exports = __webpack_public_path__ + "assets/img/64@3x.e040a564.png";